import { useMutation } from '@tanstack/react-query'

import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@/config'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { MutationConfig } from '@/lib/react-query'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'
import { storage } from '@/utils/storage'

import { resetUser } from '../user'

const logout = () => {
  if (isDenebEnabled) {
    return aspidaClient.v1.employee.logout.$put()
  }
  return aspidaClient.v1.logout.$put()
}

type UseLogoutOptions = {
  config?: Omit<MutationConfig<typeof logout>, 'onSuccess'>
}

export const useLogout = ({ config }: UseLogoutOptions) => {
  const { clearProxyStore } = useProxyStore()

  return useMutation({
    ...config,
    mutationFn: logout,
    onSuccess: async () => {
      storage.remove(ACCESS_TOKEN_KEY)
      storage.remove(REFRESH_TOKEN_KEY)
      clearProxyStore()
      await resetUser()
    },
    onSettled: (_data, error) => {
      if (error === null) {
        queryClient.invalidateQueries()
      }
    },
  })
}
